<template>
  <div v-loading="loading">
    <div class="course-header">
      <div class="course-header-content">
        <img
          src="https://res.hangxintong.cn/nxjpWx/icon/gk-xq.png"
          style="width: 146px; height: 36px"
        />
        <el-button
          @click="router.go(-1)"
          link
          type="primary"
          style="color: #3d9aff"
          >返回
        </el-button>
      </div>
    </div>
    <div class="course-info">
      <div class="course-info-content">
        <div>
          <img
            v-if="courseInfo.product.categoryType == 1"
            src="https://res.hangxintong.cn/nxjpWx/icon/xq-xks.png"
            style="width: 114px; height: 36px"
          />
          <img
            v-if="courseInfo.product.categoryType == 2"
            src="https://res.hangxintong.cn/nxjpWx/icon/xq-jxs.png"
            style="width: 114px; height: 36px"
          />
          <div class="course-tag">
            {{ courseInfo.product.name || '--' }}
          </div>
        </div>
        <div style="display: flex">
          <div v-if="userStore.getUserInfo">
            <el-button
              v-if="!courseInfo.product.collect"
              plain
              size="large"
              @click="collect"
              style="height: 32px; width: 76px"
            >
              <template #icon>
                <el-icon size="16">
                  <Star />
                </el-icon>
              </template>
              <span>收藏</span>
            </el-button>
            <el-button
              v-else
              plain
              size="large"
              @click="cancelCollect"
              style="height: 32px; width: 76px"
            >
              <template #icon>
                <el-icon color="#FADB14" size="16">
                  <StarFilled />
                </el-icon>
              </template>
              <span>已收藏</span>
            </el-button>
          </div>
          <el-popover
            placement="right"
            :width="200"
            trigger="click"
            @show="getQrCode"
          >
            <template #reference>
              <el-button
                plain
                icon="Share"
                size="large"
                style="height: 32px; width: 76px; margin-left: 20px"
                >分享
              </el-button>
            </template>
            <div v-loading="qrCodeLoading" class="share-popover">
              <div class="share-title">分享</div>
              <div class="qr-container"
                ><img v-if="qrCode" :src="qrCode" class="qr-image"
              /></div>
              <div class="share-tip"
                ><img
                  src="@/assets/img/icon-weChat.png"
                  class="wechat-icon"
                />微信扫码
              </div>
            </div>
          </el-popover>
        </div>
      </div>
      <div class="course-info-danwei">
        <div>
          <div style="display: flex">
            <div class="tab-info">
              共{{ totalNum }}章
              <el-divider direction="vertical" />
              {{ classHours }}课时
              <el-divider direction="vertical" />
              {{ targetHours }}学时达标
            </div>
          </div>
        </div>
        <div class="course-info-jiages">
          <div class="course-info-tag">
            <div class="itemTag">
              {{ courseInfo.product.manageDeptName || '' }}
            </div>
            <div class="itemTag">
              {{ courseInfo.product.categoryName || '' }}
            </div>
          </div>
          <div style="display: flex; align-items: center; margin-top: -10px">
            <div>
              <span class="KCnoe">课程价格：</span>
              <span style="color: #ff511f">￥</span>
              <span class="price">{{ courseInfo.product.price }}</span>
            </div>
            <div style="display: flex">
              <div class="cart-gray" @click="addToCart(courseInfo.product)">
                <el-icon style="font-size: 21px" color="#ff511f">
                  <ShoppingCart />
                </el-icon>
                <span>&nbsp;为他人购买</span>
              </div>
              <div class="cart-UserFilled" @click="toPay">
                <el-icon style="font-size: 21px" color="#fff">
                  <User />
                </el-icon>
                <span>&nbsp;为自己购买</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="course-content">
      <el-tabs v-model="tabName" class="demo-tabs" @tab-click="changeTab">
        <el-tab-pane label="课程简介" name="2">
          <div class="tab-info">
            共{{ totalNum }}章，{{ classHours }}课时，{{ targetHours }}学时达标
          </div>
          <div v-if="introduction && introduction.length > 0">
            <div v-for="(item, index) in introduction" :key="index">
              <div class="tabIntroduction" v-if="item.content == '课程概述'">
                <div class="IntroductionTitle">
                  <img
                    src="https://res.hangxintong.cn/nxjpWx/icon/ck-gs.png"
                    style="width: 24px; height: 24px; margin-right: 5px"
                  />
                  课程概述
                </div>
                <div
                  class="IntroductionContent"
                  v-html="item.description"
                ></div>
              </div>
              <div
                class="tabIntroduction"
                v-else-if="item.content == '讲师介绍'"
              >
                <div class="IntroductionTitle">
                  <img
                    src="https://res.hangxintong.cn/nxjpWx/icon/js-js.png"
                    style="width: 24px; height: 24px; margin-right: 5px"
                  />
                  讲师介绍
                </div>
                <div
                  class="IntroductionContent"
                  v-html="item.description"
                ></div>
              </div>
              <div class="tabIntroduction" v-else>
                <div class="IntroductionTitle">
                  <img
                    src="https://res.hangxintong.cn/nxjpWx/icon/kc-xq.png"
                    alt=""
                    style="width: 24px; height: 24px; margin-right: 5px"
                  />
                  {{ item.content }}
                </div>
                <div
                  class="IntroductionContent"
                  v-html="item.description"
                ></div>
              </div>
            </div>
          </div>
          <el-empty
            v-else
            description="暂无介绍"
            :image-size="100"
            image="https://res.hangxintong.cn/uniXkb/status/s3.png"
          />
        </el-tab-pane>
        <el-tab-pane label="目录" name="1">
          <div class="tab-info">
            共{{ totalNum }}章，{{ classHours }}课时，{{ targetHours }}学时达标
          </div>
          <el-collapse v-if="courseList.length > 0" v-model="activeNames">
            <el-collapse-item
              :title="
                course.courseName + '（' + '学时：' + course.classHours + '）'
              "
              v-for="(course, index) in courseList"
              :key="index"
              :name="index"
              class="el-collapse-item"
            >
              <div
                v-for="(chapter, idx) in course.chapters"
                class="u-collapse-content"
                :key="idx"
              >
                <div class="chapter-title"
                  >{{ idx + 1 }}、{{ chapter.chapterTitle }}
                </div>
                <div v-for="(section, ids) in chapter.section" :key="ids">
                  <div
                    v-if="section.isTryLearn == 1"
                    class="section-title courseName"
                  >
                    {{ section.sectionTitle || '--' }}
                  </div>
                  <!-- {{section.isTryLearn}} 0 不能 1可以试看-->
                </div>
              </div>
            </el-collapse-item>
          </el-collapse>
          <el-empty
            v-else
            description="暂无课程"
            :image-size="100"
            image="https://res.hangxintong.cn/uniXkb/status/s3.png"
          />
        </el-tab-pane>
      </el-tabs>
    </div>
    <el-dialog
      v-model="showRepeatTip"
      title="提示"
      width="480"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
    >
      <div class="dialog-content">
        <!--        <div class="dialog-text">您已购买过该课程，是否重复购买课程？</div>-->
        <div class="dialog-text">您已购买过该课程，不能重复购买该课程！</div>
      </div>
      <template #footer>
        <div class="dialog-footer">
          <!--          <el-button type="primary" @click="continuePay">继续购买</el-button>-->
          <el-button plain @click="showRepeatTip = false"> 取消</el-button>
        </div>
      </template>
    </el-dialog>
    <el-dialog
      v-model="SystemPrompt"
      title="系统提示"
      width="550"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
    >
      <div class="dialog-content">
        <div style="display: flex; align-items: center">
          <el-icon color="#10B87E" size="18">
            <WarningFilled />
          </el-icon>
          &nbsp;加入购物车成功
        </div>
        <div class="weinin">您为他人购买的课程已成功加入购物车！</div>
        <div class="kecname">
          课程名称： {{ courseInfo.product.name || '--' }}
        </div>
      </div>
      <template #footer>
        <div class="jixu-footer">
          <div class="cart-jixu" @click="Continuecourse"
            ><span>继续选课</span></div
          >
          <div class="cart-UserFilled" @click="Gotothe"
            ><span>去购物车结算</span></div
          >
        </div>
      </template>
    </el-dialog>
  </div>
</template>

<script setup>
import {
  getTrainCourseInfoApi,
  userCollectApi,
  getPurchasedStateApi,
  maQrCodeCreateUnlimited,
} from '@/api/course.js'
import { postFormData } from '@/api/FormApi'
import { getCourseCheckFormApi } from '@/api/learn.js'
import { cancelSelectListApi } from '@/api/user.js'
import { useUserStore } from '@/store/modules/user'
import { StarFilled } from '@element-plus/icons-vue'
import { useQrCode } from '@/hook/useQrCode'
import { shoppingCarList, shoppingCarPost } from '@/api/ShoppingCart'
import { ElMessage } from 'element-plus'
import { createOrderApi } from '@/api/order'

const { createQrCode } = useQrCode()
const SystemPrompt = ref(false)
const router = useRouter()
const route = useRoute()
const userStore = useUserStore()
const tabName = ref('1')
const loading = ref(false)
const showRepeatTip = ref(false) // 重复购买提示
const isRepeat = ref(true)
const courseInfo = ref({
  baseInfo: {},
  itemConfig: {},
  product: {},
})
const introduction = ref([])
const activeNames = ref([])
// 课程目录
const courseList = ref([])
// 评论列表数据
const commentList = ref([])
// 总章节
const totalNum = ref(0)
// 总课时
const classHours = ref(0)
// 达标学时
const targetHours = computed(() => {
  let num = 0
  if (courseInfo.value.itemConfig?.requiredTarget != null) {
    num += courseInfo.value.itemConfig.requiredTarget
  }
  if (courseInfo.value.itemConfig?.searchTarget != null) {
    num += courseInfo.value.itemConfig.searchTarget
  }
  return num
})
const qrCode = ref('') // 分享二维码
const qrCodeLoading = ref(false)
onMounted(() => {
  console.log(route.params.id)
  getTrainCourseInfo()
  if (userStore.getToken) {
    shoppingCarListFun()
  }
})

//去购物车结算
function Gotothe() {
  router.push('/cart')
}

//继续选课
function Continuecourse() {
  router.go(-1)
}

function changeTab(tab) {
  console.log(tab)
}

// 课程简介
function getTrainCourseInfo() {
  loading.value = true
  getTrainCourseInfoApi(route.params.id)
    .then(res => {
      classHours.value = 0
      courseInfo.value = res.data
      introduction.value = JSON.parse(res.data.product.introduction)
      let arr = []
      if (res.data.requiredClass) {
        res.data.requiredClass.forEach(item => {
          arr.push(item)
        })
      }
      if (res.data.searchSplit) {
        res.data.searchSplit.forEach(item => {
          arr.push(item)
        })
      }
      arr.forEach((it, index) => {
        totalNum.value += it && it.chapters && it.chapters.length
        it &&
          it.chapters &&
          it.chapters.forEach(item => {
            item.section.forEach(j => {
              classHours.value += j.classHours
            })
          })
        // 默认展开全部目录
        activeNames.value.push(index)
      })
      // courseList.value = arr
      // classHours.value = 0
      console.log(courseList.value)
      courseList.value = arr.map(item => {
        item.classHours = 0
        item.chapters.map(j => {
          j.section.map(inn => {
            item.classHours += inn.classHours
            return inn
          })
          // classHours.value += j.classHours
          return j
        })
        return item
      })
      loading.value = false
    })
    .catch(() => {
      loading.value = false
    })
}

//为他人购买
function addToCart(item) {
  if (!userStore.getToken) {
    userStore.setShowLogin(true)
    return
  }
  let data = {
    goodsId: item.id, //商品id
    goodsClassId: item.categoryId, //分类id
    unitPrice: item.price, //单价
    quantity: 1, //数量
  }
  shoppingCarPost(data).then(res => {
    console.log(res, 'resresres')
    if (res.code == 1000) {
      shoppingCarListFun()
      SystemPrompt.value = true
      ElMessage.success('该课程已添加购物车')
    }
  })
}

function shoppingCarListFun() {
  shoppingCarList().then(res => {
    // cartCount.value = res.data.list.length
    console.log('res22222222222', res)
    // 通过全局事件总线发送购物车数量
    emitter.emit('cartCountUpdate', res.data.list.length)
    // 存储到 localStorage 以便其他页面获取
    localStorage.setItem('cartCount', res.data.list.length)
  })
}

// 报名课程
function toPay() {
  if (!userStore.getToken) {
    userStore.setShowLogin(true)
    return
  }
  loading.value = true
  // 检查是否重复购买
  getPurchasedStateApi(route.params.id)
    .then(res => {
      loading.value = false
      isRepeat.value = res.data
      if (!isRepeat.value) {
        // 重复报名
        showRepeatTip.value = true
        return
      } else {
        showRepeatTip.value = false
        // 查询表单
        const data = {
          resourceType: 'product',
          resourceId: route.params.id,
        }
        getCourseCheckFormApi(data)
          .then(res => {
            showRepeatTip.value = false
            if (res.data.needFill) {
              // 报名需要填写表单
              router.push(
                `/CustomerForm/index?FormId=${res.data.formId}&type=product&resourceId=${route.params.id}&certClassId=${courseInfo.value.product.certClassId}&certClassName=${courseInfo.value.product.certClassName}`
              )
            } else {
              // router.push('/placeOrder?id=' + route.params.id + '&enrollId=' + '')
              const courseObj = {
                productId: route.params.id,
                num: 1,
                orderScene: 'purchaseCourse',
                enrollId: '',
              }
              createOrderApi(courseObj)
                .then(res => {
                  router.push('/orderDetail?id=' + res.data.id)
                })
                .finally(() => {
                  loading.value = false
                })
            }
          })
          .finally(() => {
            loading.value = false
          })
      }
    })
    .catch(err => {
      console.log(err)
      loading.value = false
    })
}

// 重复购买 继续购买
// function continuePay() {
//   // 查询表单
//   const data = {
//     resourceType: 'prodoct',
//     resourceId: route.params.id,
//   }
//   getCourseCheckFormApi(data).then(res => {
//     showRepeatTip.value = false
//     if (res.data.needFill) {
//       // 报名需要填写表单
//       router.push(
//         `/CustomerForm/index?FormId=${res.data.formId}&type=prodoct&resourceId=${route.params.id}`
//       )
//     } else {
//       // const data = {
//       //   resourceType: 'prodoct',
//       //   productId: route.params.id,
//       // }
//       // postFormData(data).then(res => {
//       //   if (res.code == 1000) {
//       router.push('/placeOrder?id=' + route.params.id + '&enrollId=' + '')
//       //   } else {
//       //     ElMessage({ message: res.msg, type: 'error' })
//       //   }
//       // })
//     }
//     // }
//   })
// }

// 收藏
function collect() {
  // 未登录
  if (!userStore.getToken) {
    userStore.setShowLogin(true)
    return
  }
  const data = {
    resourceType: 'product',
    resourceId: route.params.id,
  }
  userCollectApi(data).then(res => {
    console.log(res)
    ElMessage.success('收藏成功')
    courseInfo.value.product.collect = true
  })
}

// 取消收藏
function cancelCollect() {
  // 未登录
  if (!userStore.getToken) {
    userStore.setShowLogin(true)
    return
  }
  cancelSelectListApi(route.params.id).then(res => {
    ElMessage.success('取消收藏')
    courseInfo.value.product.collect = false
  })
}

async function getQrCode() {
  qrCodeLoading.value = true
  qrCode.value = ''
  try {
    const res = await maQrCodeCreateUnlimited(
      route.params.id,
      `pagesBuyCourseCenter/courseDetails/courseDetails`,
      import.meta.env.VITE_APP_PLATFORM_TYPE
    )

    // 如果接口返回的是二维码数据，需要转换为图片
    if (res.data.qrcode) {
      // 如果返回的是 base64 格式，直接使用
      if (res.data.qrcode.startsWith('data:image/')) {
        qrCode.value = res.data.qrcode
      }
      // 如果返回的是 URL，直接使用
      else if (
        res.data.qrcode.startsWith('http://') ||
        res.data.qrcode.startsWith('https://')
      ) {
        qrCode.value = res.data.qrcode
      }
      // 如果返回的是纯 base64 字符串，添加 data URL 前缀
      else if (res.data.qrcode.match(/^[A-Za-z0-9+/]*={0,2}$/)) {
        qrCode.value = `data:image/png;base64,${res.data.qrcode}`
      }
      // 其他情况，尝试直接使用
      else {
        qrCode.value = res.data.qrcode
      }
    }
    qrCodeLoading.value = false
  } catch (err) {
    qrCodeLoading.value = false
  }
}
</script>

<style scoped lang="scss">
.IntroductionContent {
  :deep(img) {
    max-width: 100%;
    height: auto;
  }
}
.kecname {
  font-family: PingFangSC-regular;
  color: #2c3242;
  font-weight: 400;
  font-size: 18px;
  margin-left: 16px;
}

.weinin {
  font-family: PingFangSC-medium;
  color: #2c3242;
  font-weight: 500;
  font-size: 18px;
  margin-top: 20px;
  margin-left: 16px;
}

.IntroductionTitle {
  display: flex;
  align-items: center;
  font-family: PingFangSC-medium;
  color: #18181a;
  font-weight: 500;
  font-size: 16px;
  margin-bottom: 8px;
}

.tabIntroduction {
  background: #f5f7f9;
  border-radius: 4px;
  margin-bottom: 20px;
  padding: 12px;
}

.u-collapse-content {
  padding: 0 16px;
}

.cart-jixu {
  width: 130px;
  height: 40px;
  line-height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 1px solid #e4e4e4;
  border-radius: 4px;
  background: #f2f2f6;
  cursor: pointer;

  span {
    font-family: PingFangSC-medium;
    color: #333;
    font-weight: 500;
    font-size: 15px;
  }
}

.cart-UserFilled {
  width: 130px;
  height: 40px;
  line-height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 1px solid #ff511f;
  border-radius: 4px;
  background: #ff511f;
  cursor: pointer;

  span {
    font-family: PingFangSC-medium;
    color: #fff;
    font-weight: 500;
    font-size: 15px;
  }
}

.cart-gray {
  width: 130px;
  height: 40px;
  line-height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 1px solid #ff511f;
  border-radius: 4px;
  background: #fff3f0;
  margin: 0 20px;
  cursor: pointer;

  span {
    font-family: PingFangSC-medium;
    color: #ff511f;
    font-weight: 500;
    font-size: 15px;
    padding-left: 5px;
  }
}

.price {
  font-family: DINAlternate-Bold;
  color: #ff511f;
  font-weight: 700;
  font-size: 32px;
}

.KCnoe {
  font-family: PingFangSC-medium;
  color: #4c4c4c;
  font-weight: 500;
  font-size: 16px;
}

.yanhuas {
  font-family: PingFangSC-regular;
  color: #898b92;
  font-weight: 400;
  font-size: 16px;
}

.itemTag {
  font-family: PingFangSC-regular;
  color: #6f7680;
  font-weight: 400;
  font-size: 12px;
  background: #f2f5f8;
  margin-right: 6px;
  padding: 3px 8px;
  border-radius: 4px;
}

.course-info-tag {
  display: flex;
}

.course-info-jiages {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding-bottom: 20px;
}

.course-info-danwei {
  padding: 0px 40px;
}

.course-info-content {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 20px 40px;
}

.course-info {
  max-width: 1360px;
  background: #fff;
  margin: 0 auto;
  margin-bottom: 8px;
}

.courseName:hover {
  color: #0060ef;
}

/* 自定义CSS类定义 */
/* 布局容器 */
.course-header {
  background-color: #fff;
  box-sizing: border-box;
  max-width: 1360px;
  margin: 0 auto;
  margin-bottom: 8px;
}

.course-header-content {
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 62px;
  line-height: 62px;
  padding: 0 16px;
}

.course-image {
  width: 400px;
  height: 250px;
}

.course-info {
  flex: 1;
}

.course-title {
  color: #333333;
  font-size: 28px;
  font-weight: 400;
  margin-bottom: 48px;
}

.course-tag {
  font-family: PingFangSC-semibold;
  color: #2c3242;
  font-weight: 600;
  font-size: 20px;
}

.course-price-section {
  font-size: 12px;
  color: #999999;
  margin-bottom: 40px;
}

.course-price {
  font-size: 28px;
  font-weight: 700;
  color: #ff0000;
}

.price-currency {
  font-size: 12px;
  font-family: PingFangSC-medium;
  color: #ff511f;
  font-weight: 500;
  padding: 0 5px;
}

.course-actions {
  display: flex;
  justify-content: flex-start;
  gap: 40px;
}

.buy-button {
  width: 176px;
}

/* 分享弹窗 */
.share-popover {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.share-title {
  font-size: 16px;
  color: #666;
}

.qr-container {
  height: 160px;
}

.qr-image {
  width: 160px;
  height: 160px;
}

.share-tip {
  font-size: 12px;
  color: #666;
  display: flex;
  align-items: center;
}

.wechat-icon {
  width: 24px;
  height: 24px;
  margin-right: 8px;
}

/* 内容区域 */
.course-content {
  width: 1360px;
  margin: 0 auto;
  background-color: #fff;
  padding: 24px 80px;
  box-sizing: border-box;
  height: 552px;
  overflow: auto;
}

.tab-title {
  color: #333333;
  font-size: 24px;
  font-weight: 700;
  margin-top: 9px;
  margin-bottom: 16px;
}

.tab-info {
  color: #999999;
  font-size: 16px;
  margin-bottom: 16px;
}

.chapter-title {
  font-size: 16px;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  //margin-bottom: 20px;
  padding-top: 10px;
}

.section-title {
  color: #171a1d;
  font-size: 16px;
  margin-bottom: 20px;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  cursor: pointer;
}

.course-intro {
  font-size: 20px;
  margin-top: 9px;
}

.course-intro-content {
  line-height: 1.5em;
}

/* 对话框 */
.dialog-content {
  margin: 0 22px;
  padding: 12px 16px;
}

.dialog-text {
  color: #333;
  font-size: 14px;
  margin-left: 20px;
  margin-top: 40px;
  margin-bottom: 50px;
}

.jixu-footer {
  display: flex;
  justify-content: center;
  gap: 24px;
  margin-left: 20px;
  margin-bottom: 13px;
  padding: 12px 16px;
}

.dialog-footer {
  display: flex;
  justify-content: flex-start;
  gap: 24px;
  margin-left: 20px;
  margin-bottom: 13px;
  padding: 12px 16px;
}

:deep(.el-button + .el-button) {
  margin-left: 0;
}

:deep(.el-tabs__item) {
  // font-size: 24px;
  font-size: 18px;
  padding: 0 40px;
}

:deep(.el-tabs__active-bar) {
  height: 4px;
  border-radius: 3px;
}

:deep(.el-collapse-item__header) {
  font-size: 20px;
  background: #f0f5fa;
}

:deep(.el-collapse-item__title) {
  font-family: PingFangSC-regular;
  color: #18181a;
  font-weight: 400;
  font-size: 16px;
  padding-left: 10px;
}

:deep(.el-collapse-item__arrow) {
  padding-right: 10px;
}

:deep(.el-collapse-item__content) {
  background: #fafdff;
  //margin-bottom: 20px;
}

:deep(.el-dialog) {
  padding: 0;
}

.el-collapse-item {
  margin-bottom: 12px;
  border-radius: 4px;
}

:deep(.el-dialog__header) {
  display: flex;
  align-items: center;
  padding: 0 0 0 16px;
  height: 40px;
  font-size: 14px;
  color: #333333;
}
</style>
